import { AttributeType } from './attribute-type';
import { MigrationDataType } from './workflow-creator';
export class TemplateCreator {
  Id: string;
  Name: string;
  Description: string;
  Instructions: string;
  CreateInstructions: string;
  DeploymentInstructions: string;
  DependencyMapId: string;
  Type: TemplateType;
  ConfigurationType: ConfigurationType;
  ImagePath: string;
  TemplateSections: TemplateSection[];
  ContainsDeviceConfig: boolean;
  IsSecurityTemplate: boolean;
  UpdatedDate?: string;
}

export class TemplateSection {
  Name: string;
  DisplayName: string;
  Description: string;
  ShowExpression: string;
  Order: number;
  CollectionEntryId: string;
  ProviderId?:string;
  CollectionEntryAttributeIds: string[];
  AllowMultiple: boolean;
  IsMandatory: boolean;
  Action: number;
  CollectionEntryAttributeDetails: CollectionEntryAttributeDetail[];
  //need to update
  TemplateSectionResourceDetails: TemplateSectionResourceDetail[];
  attributes: any[];
  IsShowSection: boolean;
  IsSelectionStep: boolean;
  SelectionType: string;
  SelectionAttributeName: string;
  DependentAttributeName: string;
  SectionId?: string;

  SelectionSettings: SelectionSetting[]
}

export class SelectionSetting {
  Type: SelectionSettingType;
  ProviderId?:string;
  ResourceCollectionEntryId?: string;
  SelectionOutputAttribute: string;
  SelectionOutputAttributeDisplayName?: string;
  ParentAttribute?: string;
  Value?: string;
  FilterConfig?: string;

  // Extra
  EnvironmentId?: string;
  OrganizationId?: string;
  ProjectId?: string;
}

export enum SelectionSettingType {
  'Blueprint' = 0,
  'Inventory' = 1,
  'Connectivity' = 2,
  'Device' = 3,
  'Resource' = 4,
  'SecondaryTemplate' = 5,
  'Meta' = 6,
  'Compliance' = 7,
  'ArtifactSelection' = 8,
  'BlueprintTemplate' = 9
}

export class TemplateSectionResourceDetail {
  CollectionEntryId: string;
  CollectionEntryAttributeIds: string[];
  Action: number;
}

export class CollectionEntryAttributeDetail {
  CollectionEntryAttributeId: string;
  AttributeName: string;
  AllowMultiple: boolean;
  IgnoreInBlueprint: boolean;
  ValueFrom: number;
  Action: number;
  Order: number;
  IsMandatory: boolean;
  IsComplex: boolean;
  CollectionEntryAttributeDetails: CollectionEntryAttributeDetail[];
  AttributeTypeId: string;
  IsCustomAttribute: boolean;
  CollectionAttribute: AttributeType;
  Value: any;
  ParameterId: string;
}

export enum TemplateType {
  'Form' = 0,
  'Wizard' = 1,
}

export enum ConfigurationType {
  'Configuration' = 0,
  'Flavour' = 1,
}

export enum TemplateAction {
  'Replace' = 0,
  'Append' = 1,
}

export enum ValueFrom {
  'Blueprint' = 0,
  'Template' = 1,
  'Inventory' = 2
}

